// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_36NUyE_w"};